import '@/css/app.css'
import '@signUp/sign-up.css'

import { definePreset } from '@primeuix/themes'
import SignUpRoot from '@signUp/SignUpRoot.vue'
import { registerServices } from '@/registerServices.ts'
import { PrenoThemePreset } from '@/theme.ts'

const SignUpPreset = definePreset(PrenoThemePreset, {
    components: {
        inputtext: {
            colorScheme: {
                light: {
                    root: {
                        borderColor: '#ffbf5b',
                        hoverBorderColor: '#ffbf5b',
                    },
                },
            },
        },
        select: {
            colorScheme: {
                light: {
                    root: {
                        borderColor: '#ffbf5b',
                        hoverBorderColor: '#ffbf5b',
                    },
                },
            },
        },
        slider: {
            colorScheme: {
                light: {
                    range: { background: '#ffbf5b' },
                    handle: {
                        background: '#ffbf5b',
                        hoverBackground: '#ffbf5b',
                    },
                },
            },
        },
    },
})

const app = registerServices(SignUpRoot, SignUpPreset)

app.mount('#app')
